import { z } from "zod";

export const AuthV2Request = z.object({
  code: z.string().optional(),
  state: z.string(),
  codeChallenge: z.string(),
  codeChallengeMethod: z.string(),
  redirectUri: z.string(),
  sessionId: z.string(),
});

export type AuthV2Request = z.infer<typeof AuthV2Request>;
